import { createI18n } from 'vue-i18n'
// 多语言配置
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'zhCN',
  messages: {
    zhCN: window.zhCN,
    zhHK: window.zhHK,
    enUS: window.enUS
  }
})
export default i18n
